import Controller from '../abstracts/Controller';
import 'scss-templates/t-journal-article.scss';

export default class JournalArticleController extends Controller {
  static get COMPONENTS() {
    return [
      'ArticleLoaderComponent',
      'ArticleHeroComponent',
      'ArticleHeroScrollComponent',
      'ArticleTwinScrollComponent',
      'ArticleTripleLaunchComponent',
      'ArticleGalleryComponent',
      'ArticleProductComponent',
      'ArticleProductVariantComponent',
      'ArticleLaunchScrollComponent',
      'AddToWishlistComponent',
      'WishlistComponent',
      'SeoTextComponent'
    ];
  }
}
